import { createUseStyles } from 'react-jss'
import { formTitle, formFooter, formAdditionalElementsStyles } from './drawerForms'

const useStyles = createUseStyles({
  stepTitle: {
    extend: formTitle
  },
  stepFooter: {
    extend: formFooter
  },
  stepBody: {
    marginTop: 16,
    '& .checkbox': {
      marginTop: 16,
      marginLeft: 16
    },
    extend: formAdditionalElementsStyles
  }
})

export default useStyles
